import { createEntityCollectionStore } from '@recruitee/ngrx';
import type { TalentPool } from '@recruitee/talent-pools-types';

const {
  namespace,
  actions: defaultActions,
  reducer,
  selectors: { byId },
} = createEntityCollectionStore<{
  talentPools: TalentPool[];
  id: string;
}>()('TalentPoolsByCompany');

const actions = {
  fetchOne: defaultActions.fetchOne,
  fetchOneSuccess: defaultActions.fetchOneSuccess,
  fetchOneFailed: defaultActions.fetchOneFailed,
};

const TalentPoolsByCompanySelectors = { byId };

export {
  actions as TalentPoolsByCompanyActions,
  reducer as TalentPoolsByCompanyReducer,
  TalentPoolsByCompanySelectors,
  namespace as TalentPoolsByCompanyNamespace,
};
